var _excluded = ["size"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable */

/* tslint:disable */
import React from 'react';

var dots = function dots(_ref) {
  var size = _ref.size,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5",
    height: size || "15"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M645.595 375c-1.094-.041-1.952-.954-1.924-2.05.027-1.094.929-1.963 2.024-1.95 1.094.014 1.975.905 1.975 2-.021 1.125-.95 2.02-2.075 2zm0-7c-1.094-.041-1.952-.954-1.924-2.05.027-1.094.929-1.963 2.024-1.95 1.094.014 1.975.905 1.975 2-.021 1.125-.95 2.02-2.075 2zm.15 10c1.094.041 1.952.954 1.924 2.05-.027 1.094-.929 1.963-2.024 1.95-1.094-.014-1.975-.905-1.975-2 .023-1.124.95-2.018 2.075-2z",
    transform: "translate(-643 -364)"
  }))));
};

dots.displayName = 'love_empty';
export default dots;
/* tslint:enable */

/* eslint-enable */